import gql from 'graphql-tag';

export const REDIRECT_QUERY = gql`
    query getListingData($path: String!) {
        redirects(path: $path) {
            code
            redirectUri
        }
    }
`;
